import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { getUserHeadMeta } from "@/helpers/user-meta";
import { fetchExperiences } from "@/loaders/user-experiences";
import Games from "@/pages/user/games";

const searchSchema = z.object({
  sortBy: z.string().optional(),
});

export const Route = createFileRoute(
  "/@{$username}/experiences/$category/$subcategory"
)({
  component: ExperiencesSubcategoryPage,
  head: ({ loaderData }) => {
    if (!loaderData) {
      return {};
    }
    return {
      meta: [
        ...getUserHeadMeta(loaderData.user, "experiences"),
        { content: "noindex", name: "robots" },
      ],
    };
  },
  loader: ({ params, search }) =>
    fetchExperiences({
      data: {
        category: params.category,
        sortBy: search?.sortBy,
        subcategory: params.subcategory,
        username: params.username,
      },
    }),
  validateSearch: searchSchema,
});

function ExperiencesSubcategoryPage() {
  const data = Route.useLoaderData();
  if (!data) {
    return null;
  }
  return <Games {...data} />;
}
